module.exports = __webpack_public_path__ + "static/media/Team 16 Friend 截屏2022-07-14 上午11.08.50 - T Go.1b75cfa9.png";